import { useQuery } from "@tanstack/react-query";
import { getMe } from "../actions/getMe.actions";
import type { PageBuilderMeResponseDto } from "../types/workspace.types";

export const usePageBuilderMeQuery = () => {
    const me = useQuery<PageBuilderMeResponseDto>({
        queryKey: ["page-builder-me"],
        queryFn: () => getMe(),
        staleTime: 0,
        gcTime: 5 * 60 * 1000,
    });

    return me;
};